import Container from "@client/content/Containers/container";
import { getContainerProps, getRootContainerProps } from "@client/content/lib/helper";
import { type RootContainerProps } from "@client/content/types";
import * as React from "react";
import Content from "./Content/container";

import "./style.less";

export type MapProps = RootContainerProps & {};
export interface ActionProps {}
export type Props = ActionProps & MapProps;

export default (props: ActionProps & MapProps) => (
  <Container className="wsc_content_checkout" {...getContainerProps(props)}>
    <Content {...getRootContainerProps(props)} />
  </Container>
);
